(function () {
  "use strict";
  /* ==========================================================
     NAGAIA 0.5oz overlay. nagaia-collection-v2.js owns the add queue
     and is untouched by this file.

     2026-08-22 v16 -- FIELD FIX ONLY, ON TOP OF v14. One change:
     lineFinal(). Everything else is v14 exactly.

     WHY: earlier passes detected a cart discount with
     original_line_price minus line_price. IN cart.js LINE_PRICE IS
     DEPRECATED AND CARRIES NO DISCOUNT -- it equals
     original_line_price. The discounted figures are FINAL_LINE_PRICE
     and TOTAL_DISCOUNT, so the saved amount was structurally zero and
     this drawer reported 'no discount' about a cart that was already
     discounted. THE AUTOMATIC DISCOUNT APPLIES IN THE CART; nothing
     waits for checkout, so v14's 'applied at checkout' wording is
     replaced by the amount actually saved.

     WHAT v15 GOT WRONG AND IS NOT REPEATED HERE: v15 also widened
     isTwin() to hide ANY line carrying a hidden ('_'-prefixed)
     property. THE KIT SHELL CARRIES HIDDEN PROPERTIES TOO, so the kit
     itself was filtered out -- the kit coupon line stopped computing,
     the counts went wrong, and the same widening on the cart page wiped
     the subtotal and every discount row. isTwin() is back to
     properties._kit or a 'kit only' title, which is what shipped and
     worked. DO NOT widen it without a cart dump showing exactly which
     line leaks: the kit shell and its twins look alike from a distance
     and only these two markers tell them apart.

     PRICES MATCH ACROSS DRAWER, CART AND CHECKOUT BY CONSTRUCTION:
     every figure is read from /cart.js; cart.total_price is Shopify's
     own discounted total. Nothing is estimated locally. Never
     reintroduce a local estimate -- that is what once made the drawer
     cheaper than checkout.

     v13 -- NO GATE. Deleted: IS_MEMBER, LOGIN_URL, lockedJoin, the
     .nv5-join button and handler, estD. window.nagJoinOpen() NO LONGER
     EXISTS -- never add a LOGIN_URL fallback pointing at /account.

     THE DISCOUNT: DiscountAutomaticNode/1280427458774, '20% Off
     Colors'. ACTIVE, ALL CUSTOMERS. 20% off Dip Powder, min $69.50.

     ESCAPING RULE: visible glyphs in innerHTML strings are HTML
     ENTITIES (&#10003; &#183; &#215; &#8594;), never backslash-u.
     ========================================================== */

  var SIZE_KEY = "nv5size",
    DISC_CENTS = 6950, SHIP_CENTS = 5500,
    size = sessionStorage.getItem(SIZE_KEY) === "1" ? 1 : 0,
    cartCache = null, open5 = false, toastT = null;

  var css = ""
  + "#nv2-float,#nv2-toast{display:none!important}"
  + ".nv2-vm-li{display:none!important}"
  + "body.template-collection .product-block.nv2-owned .product-block__secondary-image{opacity:0!important}"
  + "body.template-collection .product-block.nv2-owned:hover .product-block__secondary-image{opacity:1!important}"
  + ".nagaia-frame3{display:none;position:absolute;top:0;left:0;width:100%;height:100%;z-index:1}"
  + ".nagaia-frame3 img{width:100%;height:100%;object-fit:cover;display:block}"
  + ".product-block.nv5-pow .nagaia-powder-image{display:block!important}"
  + ".product-block.nv5-f3 .nagaia-frame3{display:block!important}"
  + ".product-block.nv5-pow .product-block__primary-image,.product-block.nv5-f3 .product-block__primary-image{visibility:hidden!important}"
  + ".nagaia-powder-image .nv5-pl,.nagaia-frame3 .nv5-pl{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:38px;height:38px;border-radius:50%;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;z-index:2}"
  + ".nagaia-powder-image .nv5-pl svg,.nagaia-frame3 .nv5-pl svg{width:15px;height:15px;margin-left:2px}"
  + ".product-block__image .nv5-dots{position:absolute;bottom:9px;left:9px;z-index:3;display:flex;gap:4px;align-items:center;background:rgba(20,18,16,.42);padding:5px 7px;border-radius:20px;-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)}"
  + ".product-block__image .nv5-dots i{width:5px;height:5px;border-radius:50%;background:rgba(255,255,255,.5);transition:all .18s;cursor:pointer}"
  + ".product-block__image .nv5-dots i.on{background:#fff;width:13px;border-radius:3px}"
  + ".nv2-meta{display:flex;flex-wrap:wrap;align-items:baseline;gap:3px 8px}"
  + ".nv2-meta .product-price{display:inline-flex;align-items:baseline;gap:5px;white-space:nowrap}"
  + ".nv2-meta .product-price__compare{font-size:.85em;color:#9A948E;text-decoration:line-through;font-weight:500}"
  + ".product-price__from{display:none!important}"
  + ".nv2-meta .nv2-rate{white-space:nowrap}"
  + ".nv5-seg-li{list-style:none;flex-shrink:0}"
  + ".nv5-seg{display:inline-flex;background:#F5F2F0;border:1.5px solid #E2DCD5;border-radius:22px;padding:2px}"
  + ".nv5-seg button{all:unset;box-sizing:border-box;font-family:'Inter Tight',sans-serif;font-size:11px;font-weight:600;padding:7px 14px;border-radius:18px;color:#7A7076;cursor:pointer;white-space:nowrap;line-height:1.3;display:block}"
  + ".nv5-seg button.on{background:#1A1A1A;color:#fff;font-weight:700}"
  + ".nv5-fc{position:fixed;right:14px;bottom:14px;z-index:80;font-family:'Inter Tight',sans-serif}"
  + ".nv5-pill{all:unset;box-sizing:border-box;display:flex;align-items:center;gap:9px;background:#1A1A1A;color:#fff;border-radius:14px;padding:11px 16px;cursor:pointer;box-shadow:0 6px 26px rgba(0,0,0,.22);font-family:'Inter Tight',sans-serif;max-width:calc(100vw - 28px)}"
  + ".nv5-fc.gr .nv5-pill{background:#3A8B5C}"
  + ".nv5-pill b{font-size:13px;font-weight:800}"
  + ".nv5-pill small{font-size:10.5px;opacity:.82;display:block;text-align:left;font-weight:600}"
  + ".nv5-pill .tt{font-size:15px;font-weight:800;border-left:1px solid rgba(255,255,255,.22);padding-left:11px;flex-shrink:0}"
  + ".nv5-pan{position:absolute;right:0;bottom:calc(100% + 10px);width:330px;max-width:calc(100vw - 28px);background:#fff;border-radius:15px;box-shadow:0 12px 44px rgba(0,0,0,.24);padding:15px;display:none}"
  + ".nv5-fc.open .nv5-pan{display:block}"
  + ".nv5-hd{display:flex;justify-content:space-between;align-items:center;gap:10px;margin-bottom:10px}"
  + ".nv5-hd b{font-size:14.5px;font-weight:800;color:#1A1A1A}"
  + ".nv5-x{all:unset;box-sizing:border-box;width:32px;height:32px;border-radius:50%;background:#F1EDE8;color:#6B6660;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0}"
  + ".nv5-x:hover{background:#E4DED7;color:#1A1A1A}"
  + ".nv5-x svg{width:13px;height:13px;display:block}"
  + ".nv5-lis{max-height:150px;overflow-y:auto;margin-bottom:11px}"
  + ".nv5-li{display:flex;align-items:center;gap:8px;padding:6px 1px;border-bottom:1px solid #F5F1EC;font-size:12.5px;color:#1A1A1A}"
  + ".nv5-ln{flex:1;min-width:0;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}"
  + ".nv5-lz{font-size:10px;font-weight:700;color:#C92072;background:#FDEEF5;padding:2px 6px;border-radius:5px;white-space:nowrap}"
  + ".nv5-lp{font-weight:700;white-space:nowrap}"
  + ".nv5-li .nv2-fc-rm{all:unset;box-sizing:border-box;position:relative;background:transparent;color:#B0A8A0;font-size:13px;cursor:pointer;padding:4px 6px;font-family:'Inter Tight',sans-serif;line-height:1;border-radius:4px}"
  + ".nv5-li .nv2-fc-rm::after{display:none!important}"
  + ".nv5-li .nv2-fc-rm:hover{background:#F1EDE8!important;color:#1A1A1A!important}"
  + ".nv5-ms{border:1px solid #E2DCD5;border-radius:11px;padding:14px;margin-bottom:11px}"
  + ".nv5-mkw{display:flex;gap:10px;margin-bottom:8px;align-items:flex-end}"
  + ".nv5-mkl{flex:1 1 0;min-width:0;font-size:9.5px;line-height:1.25;font-weight:700;color:#9A948E;letter-spacing:.01em;text-align:right}"
  + ".nv5-mkl.done{color:#3A8B5C}"
  + ".nv5-track{position:relative;height:6px;border-radius:3px;background:#F0ECE6}"
  + ".nv5-tfill,.nv5-tfill2{position:absolute;top:0;height:100%;border-radius:3px;background:#FF3F9E;transition:width .3s ease}"
  + ".nv5-tfill{left:0}"
  + ".nv5-tfill2{left:50%}"
  + ".nv5-mk{position:absolute;top:50%;width:13px;height:13px;border-radius:50%;background:#fff;border:2px solid #D9D2CA;box-sizing:border-box;transform:translate(-50%,-50%);z-index:2}"
  + ".nv5-mk.done{background:#3A8B5C;border-color:#3A8B5C}"
  + ".nv5-mk.end{transform:translate(-100%,-50%)}"
  + ".nv5-note{font-size:11.5px;font-weight:600;color:#3D3833;margin-top:13px;text-align:center;line-height:1.45}"
  + ".nv5-note.ok{color:#3A8B5C}"
  + ".nv5-note a{color:#C92072;font-weight:800;text-decoration:underline;text-underline-offset:2px}"
  + ".nv5-kc{font-size:11.5px;font-weight:600;color:#3D3833;margin-top:6px;text-align:center;line-height:1.45}"
  + ".nv5-kc b{color:#3A8B5C;font-weight:800}"
  + ".nv5-kc .ck{color:#3A8B5C}"
  + ".nv5-tot{display:flex;justify-content:space-between;font-size:13px;font-weight:800;color:#1A1A1A;margin-bottom:11px}"
  + ".nv5-tot .was{font-size:11.5px;font-weight:600;color:#B0A8A0;text-decoration:line-through;margin-right:6px}"
  + ".nv5-cta{display:block;text-align:center;font-size:12px;font-weight:800;color:#fff!important;background:#FF3F9E;border-radius:9px;padding:12px;text-decoration:none!important;text-transform:uppercase;letter-spacing:.03em}"
  + ".nv5-toast{position:fixed;left:50%;bottom:76px;transform:translate(-50%,8px);z-index:95;background:#1A1A1A;color:#fff;font-size:12.5px;font-weight:700;padding:10px 16px;border-radius:22px;box-shadow:0 6px 22px rgba(0,0,0,.25);opacity:0;transition:all .22s;white-space:nowrap;pointer-events:none;font-family:'Inter Tight',sans-serif}"
  + ".nv5-toast.show{opacity:1;transform:translate(-50%,0)}"
  + ".nv5-toast.ok{background:#3A8B5C}";
  var st = document.createElement("style");
  st.textContent = css; document.head.appendChild(st);

  function $(s, r) { return (r || document).querySelector(s); }
  function money(c) { return "$" + (c / 100).toFixed(2); }
  function esc(s) { return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;"); }

  /* THE FIX. line_price is DEPRECATED in cart.js and carries no
     discount -- final_line_price / total_discount do. */
  function lineOrig(it) {
    if (typeof it.original_line_price === "number") return it.original_line_price;
    return it.line_price || 0;
  }
  function lineFinal(it) {
    if (typeof it.final_line_price === "number") return it.final_line_price;
    if (typeof it.total_discount === "number") return lineOrig(it) - it.total_discount;
    return (typeof it.line_price === "number") ? it.line_price : lineOrig(it);
  }

  function frameCount(im) {
    return 1 + (im.querySelector(".nagaia-powder-image") ? 1 : 0)
             + (im.querySelector(".nagaia-frame3") ? 1 : 0);
  }
  function initDots() {
    document.querySelectorAll(".product-block .product-block__image").forEach(function (im) {
      if (im.querySelector(".nv5-dots")) return;
      var total = frameCount(im);
      if (total < 2) return;
      var d = document.createElement("div");
      d.className = "nv5-dots";
      var h = "";
      for (var i = 0; i < total; i++) h += '<i' + (i === 0 ? ' class="on"' : "") + ' data-k="' + i + '"></i>';
      d.innerHTML = h;
      im.appendChild(d);
    });
  }
  function curFrame(card) {
    return card.classList.contains("nv5-f3") ? 2 : (card.classList.contains("nv5-pow") ? 1 : 0);
  }
  function setFrame(card, k) {
    if (!card) return;
    card.classList.toggle("nv5-pow", k === 1);
    card.classList.toggle("nv5-f3", k === 2);
    var d = card.querySelector(".nv5-dots");
    if (!d) return;
    for (var i = 0; i < d.children.length; i++) d.children[i].classList.toggle("on", i === k);
  }
  document.addEventListener("pointerdown", function (e) {
    var im = e.target.closest && e.target.closest(".product-block__image");
    if (im) { im._x = e.clientX; im._sw = false; }
  }, true);
  document.addEventListener("pointerup", function (e) {
    var im = e.target.closest && e.target.closest(".product-block__image");
    if (!im || im._x == null) return;
    var dx = e.clientX - im._x;
    im._x = null;
    if (Math.abs(dx) < 25) return;
    im._sw = true;
    var card = im.closest(".product-block"), max = frameCount(im) - 1;
    var next = curFrame(card) + (dx < 0 ? 1 : -1);
    if (next < 0) next = 0;
    if (next > max) next = max;
    setFrame(card, next);
  }, true);
  document.addEventListener("click", function (e) {
    var dot = e.target.closest && e.target.closest(".nv5-dots i");
    if (dot) {
      e.preventDefault(); e.stopPropagation();
      setFrame(dot.closest(".product-block"), +dot.dataset.k);
      return;
    }
    var im = e.target.closest && e.target.closest(".product-block__image");
    if (im && im._sw) { e.preventDefault(); e.stopPropagation(); im._sw = false; }
  }, true);

  function applySize() {
    document.querySelectorAll('.product-block[data-has-sizes] .nagaia-quick-add').forEach(function (b) {
      var id = size ? b.dataset.v1Id : b.dataset.v05Id,
        cents = size ? b.dataset.v1Cents : b.dataset.v05Cents,
        p = size ? b.dataset.v1P : b.dataset.v05P,
        c = size ? b.dataset.v1C : b.dataset.v05C;
      if (!id) return;
      b.setAttribute("data-variant-id", id);
      b.setAttribute("data-cents", cents);
      var card = b.closest(".product-block");
      var amt = $(".nv5-amt", card), cut = $(".nv5-cut", card);
      if (amt && amt.innerHTML !== p) amt.innerHTML = p;
      if (cut) {
        if (c) { if (cut.innerHTML !== c) cut.innerHTML = c; cut.style.display = ""; }
        else cut.style.display = "none";
      }
      var pc = null;
      if (c) {
        var cc = parseFloat(String(c).replace(/[^0-9.]/g, "")) * 100;
        if (cc > 0) pc = Math.round((1 - cents / cc) * 100);
      }
      var sl = $(".nv5-savelb", card);
      if (sl) {
        if (pc !== null && pc > 0) {
          var txt = "Save " + pc + "%";
          if (sl.textContent !== txt) sl.textContent = txt;
          sl.style.display = "";
        } else sl.style.display = "none";
      }
    });
  }

  function killVm() {
    var l = document.querySelectorAll(".nv2-vm-li");
    for (var i = 0; i < l.length; i++) l[i].parentNode.removeChild(l[i]);
  }

  function injectSeg() {
    killVm();
    var row = document.getElementById("nagaia-color-row");
    if (!row) return;
    var ul = row.querySelector("ul.nv2-pills");
    if (!ul) return;
    var existing = ul.querySelector(".nv5-seg-li");
    if (!document.querySelector('.product-block[data-has-sizes]')) {
      if (existing) existing.parentNode.removeChild(existing);
      return;
    }
    if (existing) return;
    var li = document.createElement("li");
    li.className = "nv5-seg-li";
    li.innerHTML = '<div class="nv5-seg">'
      + '<button type="button" data-s="0"' + (size === 0 ? ' class="on"' : "") + ">0.5 oz</button>"
      + '<button type="button" data-s="1"' + (size === 1 ? ' class="on"' : "") + ">1 oz</button></div>";
    ul.insertBefore(li, ul.firstChild);
    li.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-s]");
      if (!b) return;
      size = +b.dataset.s;
      sessionStorage.setItem(SIZE_KEY, String(size));
      li.querySelectorAll("button").forEach(function (x) { x.classList.toggle("on", x === b); });
      applySize();
    });
  }

  function toast(html, ok) {
    var t = document.getElementById("nv5-toast");
    if (!t) { t = document.createElement("div"); t.id = "nv5-toast"; t.className = "nv5-toast"; document.body.appendChild(t); }
    t.className = "nv5-toast" + (ok ? " ok" : "");
    t.innerHTML = html;
    requestAnimationFrame(function () { t.classList.add("show"); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { t.classList.remove("show"); }, 2000);
  }

  function isColorLine(it) {
    var h = ((it.handle || "") + " " + (it.product_title || "")).toLowerCase();
    if (h.indexOf("kit") !== -1) return false;
    var pt = (it.product_type || "").toLowerCase();
    return pt.indexOf("powder") !== -1 || pt.indexOf("color") !== -1
        || pt.indexOf("shimmer") !== -1 || pt.indexOf("glitter") !== -1;
  }

  /* UNCHANGED from what shipped and works. The kit shell also carries
     hidden properties, so a blanket '_'-prefix test would hide the kit
     itself and take the coupon line, the counts and the cart totals
     with it (that regression shipped once -- do not repeat it). */
  function isTwin(it) {
    if (it.properties && it.properties._kit) return true;
    return ((it.product_title || it.title || "").toLowerCase().indexOf("kit only") !== -1);
  }

  function render(cart) {
    cartCache = cart;
    var fc = document.getElementById("nv5-float");
    var items = (cart.items || []).filter(function (it) { return !isTwin(it); });
    var nKits = 0, nColors = 0, nOther = 0;
    items.forEach(function (it) {
      var kitish = ((it.handle || "") + " " + (it.product_title || "")).toLowerCase().indexOf("kit") !== -1;
      if (kitish) nKits += it.quantity;
      else if (isColorLine(it)) nColors += it.quantity;
      else nOther += it.quantity;
    });
    var n = nKits + nColors + nOther;
    if (!n) { if (fc) fc.style.display = "none"; return; }
    if (!fc) { fc = document.createElement("div"); fc.id = "nv5-float"; fc.className = "nv5-fc"; document.body.appendChild(fc); }
    fc.style.display = "block";

    var sub = 0, colorSub = 0, colorRealSaved = 0, kitCoupCents = 0;
    items.forEach(function (it) {
      var orig = lineOrig(it), fin = lineFinal(it);
      sub += orig;
      if (isColorLine(it)) {
        colorSub += orig;
        if (fin < orig) colorRealSaved += (orig - fin);
      } else if (((it.handle || "") + " " + (it.product_title || "")).toLowerCase().indexOf("kit") !== -1) {
        kitCoupCents += Math.max(0, orig - fin);
      }
    });

    var showD = colorSub >= DISC_CENTS,
      payShow = cart.total_price,
      hasS = payShow >= SHIP_CENTS;

    var shipPct = Math.min(1, payShow / SHIP_CENTS) * 50,
      discPct = hasS ? Math.min(1, colorSub / DISC_CENTS) * 50 : 0;

    var lis = items.map(function (it) {
      var szTxt = (it.variant_title && it.variant_title !== "Default Title")
        ? it.variant_title
        : (isColorLine(it) ? "1 oz" : "");
      var sz = szTxt ? '<span class="nv5-lz">' + esc(szTxt) + "</span>" : "";
      return '<div class="nv5-li"><span class="nv5-ln">' + esc(it.product_title) + "</span>" + sz
        + '<span class="nv5-lp">' + money(lineOrig(it))
        + (it.quantity > 1 ? " &#215;" + it.quantity : "") + "</span>"
        + '<button type="button" class="nv2-fc-rm" data-key="' + it.key + '" aria-label="Remove">&#215;</button></div>';
    }).join("");

    var endLabel = showD ? "&#10003; 20% off colors" : "20% off colors $69.50";

    var note;
    if (hasS && showD) {
      note = colorRealSaved > 0
        ? "&#10003; Free shipping + 20% off colors &#183; you saved " + money(colorRealSaved)
        : "&#10003; Free shipping + 20% off colors";
    } else if (hasS) {
      note = "&#10003; Free shipping &#183; add " + money(DISC_CENTS - colorSub) + " of colors to save 20%";
    } else if (showD) {
      note = "&#10003; 20% off colors &#183; add " + money(SHIP_CENTS - payShow) + " for free shipping";
    } else {
      note = "Add " + money(SHIP_CENTS - payShow) + " for free shipping";
    }

    var pillSmall;
    if (hasS && showD) pillSmall = "&#10003; 20% off + free shipping";
    else if (hasS) pillSmall = "&#10003; Free shipping &#183; " + money(DISC_CENTS - colorSub) + " to 20% off";
    else if (showD) pillSmall = "&#10003; 20% off &#183; " + money(SHIP_CENTS - payShow) + " to free shipping";
    else pillSmall = money(SHIP_CENTS - payShow) + " to free shipping";

    var pp = [];
    if (nKits) pp.push(nKits + " kit" + (nKits > 1 ? "s" : ""));
    if (nColors) pp.push(nColors + " color" + (nColors > 1 ? "s" : ""));
    if (!pp.length && nOther) pp.push(nOther + " item" + (nOther > 1 ? "s" : ""));
    if (!pp.length) pp.push(n + " item" + (n > 1 ? "s" : ""));
    var pillParts = pp.join(" + ");

    fc.className = "nv5-fc" + (hasS && showD ? " gr" : "") + (open5 ? " open" : "");
    fc.innerHTML =
      '<div class="nv5-pan">'
      + '<div class="nv5-hd"><b>Your bag</b><button type="button" class="nv5-x" aria-label="Close">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button></div>'
      + '<div class="nv5-lis">' + lis + "</div>"
      + '<div class="nv5-ms">'
      +   '<div class="nv5-mkw">'
      +     '<span class="nv5-mkl' + (hasS ? " done" : "") + '">'
      +       (hasS ? "&#10003; " : "") + "Free ship $55</span>"
      +     '<span class="nv5-mkl' + (showD ? " done" : "") + '">' + endLabel + "</span>"
      +   "</div>"
      +   '<div class="nv5-track">'
      +     '<div class="nv5-tfill" style="width:' + shipPct + '%"></div>'
      +     '<div class="nv5-tfill2" style="width:' + discPct + '%"></div>'
      +     '<span class="nv5-mk' + (hasS ? " done" : "") + '" style="left:50%"></span>'
      +     '<span class="nv5-mk end' + (showD ? " done" : "") + '" style="left:100%"></span>'
      +   "</div>"
      +   '<div class="nv5-note' + (hasS && showD ? " ok" : "") + '">' + note + "</div>"
      +   (kitCoupCents > 0
        ? '<div class="nv5-kc"><span class="ck">&#10003;</span> Kit coupon applied <b>&#8722;' + money(kitCoupCents) + '</b></div>'
        : "")
      + "</div>"
      + '<div class="nv5-tot"><span>Total</span><span>' + (sub > payShow ? '<span class="was">' + money(sub) + "</span>" : "") + money(payShow) + "</span></div>"
      + '<a class="nv5-cta" href="/cart">View cart &#8594;</a>'
      + "</div>"
      + '<button type="button" class="nv5-pill" aria-expanded="' + (open5 ? "true" : "false") + '">'
      + "<span><b>" + pillParts + "</b><small>" + pillSmall
      + '</small></span><span class="tt">' + money(payShow) + "</span></button>";
  }

  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === "string") ? input : (input && input.url) || "";
    var p = _fetch.apply(this, arguments);
    if (url.indexOf("/cart.js") !== -1 || url.indexOf("/cart/change.js") !== -1) {
      p.then(function (r) { return r.clone().json(); })
        .then(function (cart) { if (cart && cart.items) render(cart); })
        .catch(function () {});
    } else if (url.indexOf("/cart/add.js") !== -1) {
      p.then(function (r) {
        if (!r.ok) return;
        return r.clone().json().then(function (added) {
          var it = added && (added.items ? added.items[0] : added);
          if (!it) return;
          var cSub = 0;
          if (cartCache) (cartCache.items || []).forEach(function (x) {
            if (!isTwin(x) && isColorLine(x)) cSub += lineOrig(x);
          });
          if (isColorLine(it)) cSub += it.price;
          if (cSub >= DISC_CENTS) toast("Added &#10003; &#183; 20% off colors unlocked", true);
          else toast("Added &#10003; &#183; " + money(DISC_CENTS - cSub) + " more for 20% off", false);
        });
      }).catch(function () {});
    }
    return p;
  };

  document.addEventListener("click", function (e) {
    var fc = document.getElementById("nv5-float");
    if (!fc) return;
    if (e.target.closest(".nv2-fc-rm")) return;
    if (e.target.closest(".nv5-note a")) return;
    if (e.target.closest(".nv5-pill")) { open5 = !open5; fc.classList.toggle("open", open5); return; }
    if (e.target.closest(".nv5-x")) { open5 = false; fc.classList.remove("open"); return; }
    if (open5 && !e.target.closest("#nv5-float")) { open5 = false; fc.classList.remove("open"); }
  });

  function boot() { injectSeg(); applySize(); initDots(); }

  var mo = null, moT = null;
  function watchGrid() {
    if (mo || !window.MutationObserver) return;
    var target = document.querySelector(".collection-grid, .collection__products, #main-collection-product-grid, main")
      || document.body;
    mo = new MutationObserver(function () {
      clearTimeout(moT);
      moT = setTimeout(function () {
        mo.disconnect();
        boot();
        mo.observe(target, { childList: true, subtree: true });
      }, 150);
    });
    mo.observe(target, { childList: true, subtree: true });
  }

  function start() { boot(); watchGrid(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();

  document.addEventListener("filters-applied", function () {
    setTimeout(boot, 150);
    setTimeout(boot, 700);
  });
  document.addEventListener("nv2:grid-appended", function () { boot(); });

  var t0 = setInterval(boot, 1200);
  setTimeout(function () { clearInterval(t0); }, 12000);
})();
